export * from './cinema-info/cinema-info.component';
export * from './cinema-list/cinema-list.component';
export * from './contact-us/contact-us.component';
export * from './movie-info/movie-info.component';
export * from './news-info/news-info.component';
export * from './news-list/news-list.component';
export * from './promotion-info/promotion-info.component';
export * from './promotion-list/promotion-list.component';
export * from './underconstruction/underconstuction.component';
